<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RangitikeiRiverFlow"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaHautapuAtAlbasters"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RangitawaRiverFlow"></app-basic-cartesian-chart>
